// extracted by mini-css-extract-plugin
export var errorText = "error-text_hFIjsLA06nFW_baYEOJm";
export var infoMessage = "info-message_MhfDszRXCZHhISzBDZhH";
export var mainHeader = "main-header_fYY01VtFWEuEONOOr4e9";
export var noResults = "no-results_A_jrF6cpJmtveU0ndkbN";